import './index.css'
import React, { Fragment } from 'react'
import ReactDOM from 'react-dom/client'
import { App } from './App'
import { GlobalStyles } from 'twin.macro'
import { LicenseInfo } from '@mui/x-license-pro'
import * as Sentry from '@sentry/react'
import { logger } from './utils/logger'

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  tracesSampleRate: 1.0,

  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', process.env.REACT_APP_API_URL as string],
  normalizeDepth: 10,
})

logger.init()

if (process.env.REACT_APP_MUI_LICENSE_KEY) {
  LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE_KEY)
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <Fragment>
    <GlobalStyles />
    <App />
  </Fragment>,
)
